import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  box: {
    padding: 2,
    width: 250,
  },
  button: {
    marginTop: 2
  }
};
